import React, { forwardRef } from 'react';
import cx from 'classnames';
import { useProgressBar } from '../../context';
import styles from '../../ProgressBar.module.scss';
const Counter = forwardRef(({ className, ...rest }, ref) => {
    const { value, max } = useProgressBar();
    const text = `${String(value)}/${String(max)}`;
    return (React.createElement("span", { className: cx(styles.counter, className), ref: ref, ...rest }, text));
});
export default Counter;
